//#region src/schema/localization/locales/ru.ts
var e = {
	schema: {
		variants: "Варианты",
		discriminatorValue: "Значение дискриминатора",
		noAllowedValues: "Ни одно значение не удовлетворяет этому ограничению enum.",
		example: "Пример",
		examples: "Примеры",
		default: "Значение по умолчанию",
		schema: "Схема",
		emptyObject: "Пустой объект",
		showAdditionalProperties: "Показать дополнительные свойства",
		showOneMoreProperty: "Показать ещё 1 свойство",
		showMoreProperties: "Показать ещё свойства: {count}",
		forName: "для {name}",
		showSchemaDetails: "Показать детали схемы",
		oneOf: "Один из",
		anyOf: "Любой из",
		allOf: "Все из",
		not: "Не",
		unknownType: "неизвестный тип",
		propertyCount: "Свойства: {count}",
		headerCount: "Заголовки: {count}",
		recursiveReference: "Рекурсивная ссылка на {name}",
		recursive: "рекурсивно",
		additionalProperties: "дополнительные свойства",
		const: "константа",
		deprecated: "устарело",
		discriminator: "Дискриминатор",
		enum: "enum",
		format: "Формат",
		greaterThan: "больше чем",
		keys: "ключи",
		lessThan: "меньше чем",
		max: "макс.",
		min: "мин.",
		maxLength: "макс. длина",
		minLength: "мин. длина",
		multipleOf: "кратно",
		nullable: "может быть null",
		propertyNames: "имена свойств",
		pattern: "Шаблон",
		copyPattern: "Скопировать шаблон",
		readOnly: "только чтение",
		required: "обязательно",
		hideValues: "Скрыть значения",
		showAllValues: "Показать все значения",
		type: "Тип",
		unique: "уникально",
		values: "значения",
		writeOnly: "только запись",
		typeInteger: "Целые числа.",
		formatInt32: "Знаковые 32-битные целые числа (обычный целочисленный тип).",
		formatInt64: "Знаковые 64-битные целые числа (тип long).",
		formatDate: "нотация full-date по RFC 3339, раздел 5.6, например 2017-07-21",
		formatDateTime: "нотация date-time по RFC 3339, раздел 5.6, например 2017-07-21T17:32:28Z",
		formatPassword: "подсказка интерфейсу скрывать ввод",
		formatBase64: "символы в кодировке base64, например U3dhZ2dlciByb2Nrcw==",
		formatBinary: "двоичные данные, описывают файлы"
	},
	common: {
		copyDefault: "Скопировать значение по умолчанию",
		copyExample: "Скопировать пример значения"
	},
	actions: { copyLinkTo: "Скопировать ссылку на {name}" }
};
//#endregion
export { e as ru };

//# sourceMappingURL=ru.js.map